import React, { useRef, useState } from "react";
import SignaturePad from "react-signature-canvas";

interface SignaturePadComponentProps {
  saveSignature: (base64: string) => void;
  initialSignature?: string;
}

export const SignaturePadComponent: React.FC<SignaturePadComponentProps> = ({
  saveSignature,
  initialSignature
}) => {
  const padRef = useRef<SignaturePad>(null);
  const [isSigned, setIsSigned] = useState(false);
  const [showInitial, setShowInitial] = useState(!!initialSignature);

  const clearCanvas = () => {
    padRef.current?.clear();
    setIsSigned(false);
    setShowInitial(false);
    saveSignature(""); // Clear the saved signature in the parent as well
  };

  const saveSignatureInReport = () => {
    if (showInitial && initialSignature) {
      saveSignature(initialSignature);
    } else if (padRef.current) {
      saveSignature(padRef.current.toDataURL());
    }
  };

  const onEnd = () => {
    if (padRef.current && !padRef.current.isEmpty()) {
      setIsSigned(true);
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <div style={{ flex: 1, minHeight: "200px", background: "#fff", borderRadius: "8px", border: "1px solid #E5E7EB", overflow: "hidden", display: "flex", justifyContent: "center", alignItems: "center" }}>
        {showInitial ? (
          <img src={initialSignature} alt="Initial Signature" style={{ maxWidth: "100%", maxHeight: "200px" }} />
        ) : (
          <SignaturePad
            ref={padRef}
            onEnd={onEnd}
            canvasProps={{ className: "signatureComponent", style: { width: "100%", height: "200px", display: "block" } }}
          />
        )}
      </div>

      <div style={{ display: "flex", gap: "12px", marginTop: "16px" }}>
        <button
          onClick={clearCanvas}
          disabled={!isSigned && !showInitial}
          style={{
            flex: "1",
            padding: "10px 16px",
            background: (isSigned || showInitial) ? "#fee2e2" : "#F3F4F6",
            color: (isSigned || showInitial) ? "#991b1b" : "#9CA3AF",
            border: (isSigned || showInitial) ? "1px solid #fecaca" : "1px solid #E5E7EB",
            borderRadius: "8px",
            fontWeight: 600,
            cursor: (isSigned || showInitial) ? "pointer" : "not-allowed",
            transition: "all 0.2s ease"
          }}
          onMouseEnter={(e) => { if (isSigned || showInitial) e.currentTarget.style.background = "#fca5a5" }}
          onMouseLeave={(e) => { if (isSigned || showInitial) e.currentTarget.style.background = "#fee2e2" }}
        >
          Clear
        </button>

        <button
          onClick={saveSignatureInReport}
          disabled={!isSigned && !showInitial}
          style={{
            flex: "2",
            padding: "10px 16px",
            background: (isSigned || showInitial) ? "linear-gradient(135deg, #16a34a 0%, #15803d 100%)" : "#F3F4F6",
            color: (isSigned || showInitial) ? "#fff" : "#9CA3AF",
            border: "none",
            borderRadius: "8px",
            fontWeight: 600,
            cursor: (isSigned || showInitial) ? "pointer" : "not-allowed",
            boxShadow: (isSigned || showInitial) ? "0 4px 12px rgba(22,163,74,0.3)" : "none",
            transition: "all 0.2s ease"
          }}
          className={(isSigned || showInitial) ? "hover-trigger" : ""}
        >
          Save
        </button>
      </div>
    </div>
  );
};
